/** Minimal WebAudio ringtone — no audio asset to ship or fetch. Plays a repeating
 *  two-tone alert while an inbound call is ringing, and stops on answer/decline.
 *  Best-effort: browsers that block audio before a user gesture (or lack
 *  AudioContext) just stay silent — it must never throw into the call flow. */
let ctx: AudioContext | null = null;
let timer: number | null = null;

function tone(context: AudioContext, at: number, freq: number, dur: number): void {
  const osc = context.createOscillator();
  const gain = context.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, at);
  gain.gain.exponentialRampToValueAtTime(0.16, at + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  osc.connect(gain).connect(context.destination);
  osc.start(at);
  osc.stop(at + dur);
}

export const ringtone = {
  start(): void {
    try {
      const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Ctor) return;
      ctx = ctx ?? new Ctor();
      if (ctx.state === "suspended") void ctx.resume();
      const ring = () => {
        if (!ctx) return;
        const t = ctx.currentTime;
        tone(ctx, t, 480, 0.45);         // classic double-ring pair
        tone(ctx, t + 0.25, 620, 0.45);
      };
      this.stop();
      ring();
      timer = window.setInterval(ring, 2200);
    } catch {
      /* audio blocked → silent */
    }
  },
  stop(): void {
    if (timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  },
};
